import HttpService from "./htttp.service";

class AppLogsService {
  getUsers = async (params, cancelToken) => {
    return await HttpService.get("app/logs/users", params, cancelToken);
  };

  getUserUploads = async (userId, cancelToken) => {
    return await HttpService.get(`app/logs/users/${userId}`, null, cancelToken);
  };
}

export default new AppLogsService();
